import { Box } from "@mui/material";
import React from "react";
import CrossGrid from "../puzzles/crossword/CrossGrid";

/**
 * Non-interactive 12×12 crossword preview for browse cards (1:1 slot).
 */
export default function CrossBrowseGridPreview({ grid, filledCoordinates, words = [] }) {
    if (!Array.isArray(grid) || grid.length === 0) return null;

    return (
        <Box
            sx={{
                width: "100%",
                aspectRatio: "1",
                borderRadius: 1,
                bgcolor: "#fff",
                overflow: "hidden",
                flexShrink: 0,
                pointerEvents: "none",
                userSelect: "none",
                boxSizing: "border-box",
            }}
        >
            <CrossGrid
                grid={grid}
                words={words}
                wordsFound={[]}
                onClearClickedWords={() => {}}
                onClickedWords={() => {}}
                gridSize={12}
                isFullscreen={false}
                isBoldFont={false}
                filledCoordinates={filledCoordinates}
                isHintMode={false}
                highlightCells={[]}
                hideAllWords={true}
                clueNumberFontPx={9}
            />
        </Box>
    );
}
